import MyApiClient from '../../../api-client/MyApiClient';

/**
 * Scelta di un player fra i CLIENTI della struttura (03/11/2026). Tessere e soci si fanno solo per chi è già
 * cliente: prima si cercava su tutta la piattaforma e la tessera rendeva la struttura «collegata» a chiunque,
 * con accesso ai suoi dati personali (audit di sicurezza, R1). Stesso modo di «Aggiungi junior»: l'elenco dei
 * clienti si carica una volta e si filtra scrivendo.
 */
let caricati = null;

export const cercaFraIClienti = async (token, testo, minimo = 3) => {
	if (!testo || testo.trim().length < minimo) return [];
	if (!caricati || caricati.token !== token) {
		const dati = await new MyApiClient().getCustomers(token);
		caricati = { token, clienti: dati && dati.items ? dati.items : [] };
	}
	const parole = testo.toLowerCase().split(/\s+/).filter(Boolean);
	return caricati.clienti
		.filter(c => parole.every(p => (c.name || '').toLowerCase().includes(p)))
		.map(c => ({ value: c.customerUserId, label: c.name }));
};

/** Da chiamare dopo aver aggiunto un cliente, perché la ricerca seguente lo trovi. */
export const dimenticaClienti = () => { caricati = null; };
